import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";

import { AddWorkoutWithRouter } from "../components/Workouts/Add";
import Details from "../components/Workouts/Details";
import WorkoutsEditComponent from "../components/Workouts/Edit";
// Routes
import ShareWorkouts from "../components/Workouts/Share";
import WorkoutsListingScreen from "../components/Workouts/WorkoutsListingsScreen";

const noop = () => {};

// Do NOT inline these. Will cause constant remounting
const ListWorkouts = withRouter(WorkoutsListingScreen);
const EditWorkout = withRouter(WorkoutsEditComponent);
const ShareWorkout = withRouter(({ match }) => (
  <ShareWorkouts
    id={match.params.id}
    setLoading={noop}
    setShareWorkout={noop}
    setShowWorkout={noop}
    showWorkout={null}
    loading={false}
  />
));
const WorkoutDetails = withRouter(Details);

const WorkoutsComponent: React.FC = () => {
  return (
    <div id="Workouts">
      <Switch>
        <Route exact path="/workouts" component={ListWorkouts} />

        {/*
        TODO: Several of these routes DO NOT WORK as advertised

        These components must have the required props injected for them to work!
        Typing has effectively been disabled to hide this :(
        */}

        <Route
          exact
          path={["/workouts/add/:id", "/workouts/add"]}
          component={AddWorkoutWithRouter}
        />
        <Route exact path="/workouts/edit/:id" component={EditWorkout} />
        <Route exact path="/workouts/share/:id" component={ShareWorkout} />
        <Route exact path="/workouts/:id" component={WorkoutDetails} />
      </Switch>
    </div>
  );
};

export default WorkoutsComponent;
